<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('bill.unbind')}}</div>
    <div slot="body">
      <dialog-selected-tips :name="$t('bill.apply_scope')" :count="params.data.length" :action="$t('bill.unbind')" />
      <dialog-table :data="params.data" :columns="params.columns.slice(0,3)" />
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'RatesetUnbindDialog',
  components: {
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
    this.$rM = new this.$Manager('ratesets', 'v1')
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        await this.$rM.performAction({
          id: this.params.rateSetId,
          action: 'unbind',
          data: this.params.data.map(item => {
            return {
              id: item.bind_id,
              type: item.type,
            }
          }),
        })
        this.loading = false
        this.cancelDialog()
        this.params.refresh()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
